import { Injectable } from '@angular/core';
import { HttpService } from '../core/services/http.service';
import { Observable } from 'rxjs';
import { JsencryptService } from '../core/services/jsencrypt.service';
import { SecurityService } from '../core/services/security.service';
import { HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  getvalue(): string {
    throw new Error('Method not implemented.');
  }
  updateUser(value: any) {
    throw new Error('Method not implemented.');
  }
  getUserById(userId: any) {
    throw new Error('Method not implemented.');
  }
  gethospital_treating_state_codegethospital_treating_state_code() {
    throw new Error('Method not implemented.');
  }
  constructor(
    private httpService: HttpService,
    private jsEncrypt: JsencryptService,
    private securityService: SecurityService
  ) { }

  getlanguage(): Promise<any[]> {
    let data = JSON.stringify({
      limit: 0,
      model: 'Languages',
      page: 1,
      fields: {
        iso_code: 'language_name',
      },
      filters: {
        status: 1,
      },
    });
    return this.httpService.post('getDropdown', data).toPromise();
  }
  //Get api dropdown value for HighestQualification fields.
  getHighestQualification(): Promise<any[]> {
    let data = JSON.stringify({
      limit: 0,
      model: 'Qualifications',
      page: 1,
      fields: {
        id: 'qualification_name',
      },
      filters: {
        status: 1,
      },
    });
    return this.httpService.post('getDropdown', data).toPromise();
  }
  // Get api dropdown value for  Identity Proof fields.
  getIdentityProof(): Promise<any[]> {
    let data = JSON.stringify({
      limit: 0,
      model: 'Identityproofs',
      page: 1,
      fields: {
        id: 'identity_name',
      },
      filters: {
        status: 1,
      },
    });
    return this.httpService.post('getDropdown', data).toPromise();
  }
  // Get api dropdown value for Nature of Document for Address Proof fields.
  getAddressProofId(): Promise<any[]> {
    let data = JSON.stringify({
      limit: 0,
      model: 'Naturedocuments',
      page: 1,
      fields: {
        id: 'name',
      },
      filters: {
        status: 1,
      },
    });
    return this.httpService.post('getDropdown', data).toPromise();
  }
  // Get api dropdown value for State fields.
  getState(): Promise<any[]> {
    let data = JSON.stringify({
      limit: 0,
      model: 'States',
      page: 1,
      fields: {
        state_code: 'name',
      },
      order: { "name": "asc" },
      filters: {
        status: 1,
      },
    });
    return this.httpService.post('getDropdown', data).toPromise();
  }
  // Get api dropdown value for District fields.
  getDistrict(state: string | number): Promise<any[]> {
    let data = JSON.stringify({
      limit: 0,
      model: 'Districts',
      page: 1,
      fields: {
        district_code: 'district_name',
      },
      order: { "district_name": "asc" },

      filters: {
        status: 1,
        state_code: state,
      },
    });
    return this.httpService.post('getDropdown', data).toPromise();
  }
  // Get api dropdown value for Sub-District fields.
  getSubDistrict(district: string | number): Promise<any[]> {
    let data = JSON.stringify({
      limit: 0,
      model: 'Subdistricts',
      page: 1,
      fields: {
        subdistrict_code: 'subdistrict_name',
      },
      order: { "subdistrict_name": "asc" },
      filters: {
        status: 1,
        district_code: district,
      },
    });
    return this.httpService.post('getDropdown', data).toPromise();
  }
  // Get api dropdown value for village fields.
  getVillage(subDistrict: string | number): Promise<any[]> {
    let data = JSON.stringify({
      limit: 0,
      model: 'Villages',
      page: 1,
      fields: {
        village_code: 'village_name',
      },
      order: { "village_name": "asc" },
      filters: {
        status: 1,
        subdistrict_code: subDistrict,
      },
    });
    return this.httpService.post('getDropdown', data).toPromise();
  }
  // Get api dropdown value for village fields.
  getpincode(district: string | number): Promise<any[]> {
    const data = JSON.stringify({
      district_code: district,
    });
    return this.httpService.post('getPincodeDropdown', data).toPromise();
  }

  // Get api dropdown value for Disibilitytypes fields.
  getdisabilitytypes(): Promise<any[]> {
    let data = JSON.stringify({
      limit: 0,
      model: 'Disabilitytypes',
      page: 1,
      fields: {
        id: 'disability_type',
      },
      filters: {
        status: 1,
      },
    });
    return this.httpService.post('getDropdown', data).toPromise();
  }
  // Get api dropdown value for Hospital Name fields.
  getHospital(district: string | number): Promise<any[]> {
    let data = JSON.stringify({
      limit: 0,
      model: 'Hospitals',
      page: 1,
      fields: {
        id: 'hospital_name',
      },
      filters: {
        status: 1,
        district_code: district,
      },
    });
    return this.httpService.post('getDropdown', data).toPromise();
  }
  // Final submission post api 
  submitApplication(data: FormData): Promise<any> {
    return this.httpService.post('savePWDForm', data).toPromise();
  };
  // Download application get data api
  getdownloadApplication(data: any): Promise<any[]> {
    return this.httpService.post('downloadApplication', data, { observe: 'response', responseType: 'blob' }).toPromise();
  }
  // Download receipt get dat api
  getdownloadreceipt(data: any): Promise<any[]> {
    return this.httpService.post('downloadApplicationReciept', data, { observe: 'response', responseType: 'blob' }).toPromise();
  }

  getfaqs(model: string): Observable<any> {
    return this.httpService.post('getList', {
      "model": "Faqs",
    });
  }
  getonlinehelpguide(model: string): Observable<any> {
    return this.httpService.post('getList', {
      "model": "ApplicationGuides",
    });
  }
  // contact us api
  // getContacts(data:any):Observable<any>{
  //   return this.httpService.post('contactUs',data)
  // }

  getContacts(data: FormData): Promise<any> {
    // const config = {
    //   headers: new HttpHeaders({
    //     "Content-Type": "multipart/form-data" // 👈
    //   })
    // };
    return this.httpService.post('contactUs', data).toPromise();
  }
  //nearestMedicalAuthority menu data show api
  getgloabaldata(): Observable<any> {
    return this.httpService.get('getglobalformdata', {});
  }
}
